import { render } from "./tw-link.vue?vue&type=template&id=8865f1ca"
import script from "./tw-link.vue?vue&type=script&lang=js"
export * from "./tw-link.vue?vue&type=script&lang=js"
script.render = render

export default script